import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { setUserLoggedOut } from './actions';


const mapStateToProps = state => ({
  global: state.Global
});

class Logout extends Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    let { global, dispatch, history } = this.props;
    //If user has been logged in recently see if validation token is still good
    if (global.token) {
      dispatch(setUserLoggedOut());
    }
    history.push('/login')
  }

  render() {
    return (<div>Logging Out...</div>)
  }
}

export default withRouter(connect(mapStateToProps)(Logout));
